import { Observable } from "apollo-link";

/**
 * @typedef {import("apollo-link").Observable} Observable
 * @type {<E>(...values: E[]) => <T>(observable: Observable<T>) => Observable<E|T>}
 */
export const onErrorResumeNext = (...values) => observable =>
	new Observable(observer => {
		let inner;
		const outer = observable.subscribe(
			observer.next.bind(observer),
			() => {
				inner = Observable.of(...values).subscribe(observer);
			},
			observer.complete.bind(observer),
		);

		return () => {
			if (outer) outer.unsubscribe();
			if (inner) inner.unsubscribe();
		};
	});

/**
 * @typedef {import("apollo-link").Observable} Observable
 * @type {<A, B>(fn: (result: A) => Observable<B>) => (observable: Observable<A>) => Observable<B>}
 */
export const flatMap = fn => observable => observable.flatMap(fn);
